export const ICandidateAeFolderFile = Object.freeze({
  identityDocumentType: "doc_type",
  filename: "filename",
  purpose: "purpose",
  verificationParameter: "verification_parameter",
  verificationParameterType: "verification_parameter_type",
});

export class CandidateAeFolderFileModel {
  constructor(data = {}) {
    this[ICandidateAeFolderFile.identityDocumentType] = data[ICandidateAeFolderFile.identityDocumentType];
    this[ICandidateAeFolderFile.filename] = data[ICandidateAeFolderFile.filename];
    this[ICandidateAeFolderFile.purpose] = data[ICandidateAeFolderFile.purpose];
    this[ICandidateAeFolderFile.verificationParameter] = data[ICandidateAeFolderFile.verificationParameter];
    this[ICandidateAeFolderFile.verificationParameterType] = data[ICandidateAeFolderFile.verificationParameterType];
  }

  getFileName() {
    return this[ICandidateAeFolderFile.filename];
  }

  getDocumentType() {
    return this[ICandidateAeFolderFile.identityDocumentType];
  }
}
